import { render, staticRenderFns } from "./ImportTemplateForm.vue?vue&type=template&id=2aa56c4c&scoped=true"
import script from "./ImportTemplateForm.vue?vue&type=script&lang=js"
export * from "./ImportTemplateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa56c4c",
  null
  
)

export default component.exports